import { Skeleton } from 'antd';
import { useUpdateToolMutation, useUploadToolCertificateMutation } from 'app/services/tools';
import { Tool, UpdateToolRequest } from 'app/types/tool';
import ToolForm from './ToolForm';
import { useGetUnitQuery } from 'app/services/me';
import { useState } from 'react';

type EditToolProps = {
  tool: Tool
};

const EditTool = ({ tool } : EditToolProps) => {
  const { data: unit } = useGetUnitQuery({ persist: true });

  const [ updateTool, toolMeta ] = useUpdateToolMutation();
  const [ uploadCertificate, fileMeta ] = useUploadToolCertificateMutation();

  const [ meta, setMeta ] = useState<any>({ isSuccess: false, data: {} });

  const handleSubmit = async (values: any) => {
    if (values.CertificateFile) {
      const fileList = values.CertificateFile as any[] | undefined;
      const first = fileList?.[0];

      if (tool?.Id && first && first.status !== 'done' && first.status !== 'error') {
        await uploadCertificate({ toolId: tool.Id, file: first.originFileObj }).unwrap();
      }
    }

    const requestBody: UpdateToolRequest = {
      id: tool!.Id,
      category: values.Category,
      make: values.Make,
      model: values.Model,
      serialNumber: values.SerialNumber,
      qrCode: values.QrCode,
      power: values.Power,
      airflow: values.Airflow,
      firstUsageTime: values.FirstUsageTime?.toDate(),
      isActive: values.IsActive,
      removeCertificate: values.CertificateFile && values.CertificateFile.length === 0,
    };

    await updateTool(requestBody).unwrap();

    setMeta({ isSuccess: true });
  };

  if (!unit || !tool) return <Skeleton active />;

  return <ToolForm
    handleSubmit={handleSubmit}
    tool={tool}
    unit={unit}
    meta={{
      isSuccess: meta.isSuccess,
      isLoading: toolMeta.isLoading || fileMeta.isLoading,
      isError: toolMeta.isError || fileMeta.isError,
      data: meta.data
    }}
  />;
};

export default EditTool;
